import React, { FC } from 'react';
import Modal from '../Modal';
import Avatar from '../Avatar';
import {
  DEFAULT_SERVICE_SUBMISSION_TITLE,
  DEFAULT_SERVICE_SUBMISSION_BODY,
} from '../../pages/ServiceBuilder/helpers';

interface ServiceIntakeCompleteModalProps {
  isModalOpen: boolean;
  setClosed: () => void;
  avatarImageUrl?: string;
  avatarName?: string;
  title?: string;
  body?: string;
}

const ServiceIntakeCompleteModal: FC<ServiceIntakeCompleteModalProps> = ({
  isModalOpen,
  setClosed,
  avatarImageUrl,
  avatarName,
  title,
  body,
}) => {
  return (
    <Modal
      name="ServiceIntakeComplete"
      isOpen={isModalOpen}
      setClosed={setClosed}
      width="small"
    >
      <div className="flex flex-col items-center justify-center px-12 pb-8">
        <Avatar
          size="xl"
          imageUrl={avatarImageUrl}
          name={avatarName}
          className="mb-6"
        />
        <div className="mb-3 w-2/3 text-center font-serif text-subtitle-small text-green-150">
          {title || DEFAULT_SERVICE_SUBMISSION_TITLE}
        </div>
        <div className="text-center text-caption text-neutral-125">
          {body || DEFAULT_SERVICE_SUBMISSION_BODY}
        </div>
      </div>
    </Modal>
  );
};

export default ServiceIntakeCompleteModal;
